import React from "react";

const EstadoBloqueado = (props) => {
    return (
        <div className="dropdown state pull-right" id={"state-block-" + props.ID}>
            <button type="button" data-toggle="dropdown" data-target={"#state-block-" + props.ID}
                className="btn btn-cta btn-sm btn-blocked">BLOQUEADO</button>
            <ul className="dropdown-menu">
                <li className="bottom-separator-xs">
                    {(!props.bloqueado_inactividad) && (<p>{"Bloqueado por " + props.Nombre + " el " + props.Fecha + " a las " + props.Hora}</p>)}
                    <p className="state-break"><i>{props.Motivo}</i></p>
                </li>
                <li className="state-bottom">
                    <div className="row">
                        {props.functions.Baja && <div className="col-xs-6 text-left">
                            <button className="btn btn-icon btn-trash" type="button" title="Eliminar usuario" onClick={() => props.setUserState(props.ID, false, false)} >
                                <span className="ti-trash"></span>
                            </button> 
                        </div>}
                        {props.functions.Modificacion && <div className="col-xs-6 text-right">
                            <button className="btn btn-secondary" type="button" onClick={() => props.setUserState(props.ID, true, false)} >Desbloquear</button>
                        </div>}
                    </div>
                </li>
            </ul>
        </div>
    );
}

export default EstadoBloqueado;